import React from 'react';

import SamePrimaryInstructorToggle from '../SamePrimaryInstructorToggle';
import SameSecondaryInstructorToggle from '../SameSecondaryInstructorToggle';
import SelectAllClasses from '../SelectAllClasses';
import styles from './ScheduleClassesBulkEditRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function ScheduleClassesBulkEditRow() {
  return (
    <TableRow className={styles.root}>
      <TableCell>
        <SelectAllClasses />
      </TableCell>
      <TableCell></TableCell>
      <TableCell>
        <SamePrimaryInstructorToggle />
      </TableCell>
      <TableCell>
        <SameSecondaryInstructorToggle />
      </TableCell>
      <TableCell></TableCell>
    </TableRow>
  );
}

export default ScheduleClassesBulkEditRow;
